<template>
  <div
    class="flex items-center gap-2 border px-2 py-1 rounded min-h-[62px]"
    @click="clickSelect"
  >
    <MateAvatarNameBioCard class="flex-1" :mate="item" />
    <template v-if="isImport">
      <button class="btn btn-xs" @click.stop="clickImport">复制为自设</button>
    </template>
    <template v-else>
      <div class="flex flex-col gap-1" v-if="item.uuid !== activeMate.uuid">
        <button class="btn btn-xs">选择</button>
        <button class="btn btn-xs" @click.stop="clickEdit">编辑</button>
      </div>
      <div v-else>
        <button class="btn btn-xs">已选择</button>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { Mate } from "@/types/entity";
import { showConfirmDialog, showLoadingToast } from "vant";
import { useRouter } from "vue-router";
import { useMate } from "@/stores/mate";
import { MateType } from "@/enums/mateEnums";

const props = defineProps<{
  item: Mate;
  activeMate: Mate;
  isImport?: boolean;
}>();

const router = useRouter();
const mateStore = useMate();

const emit = defineEmits<{
  (e: "select", mate: Mate): void;
}>();

const clickSelect = () => {
  if (props.isImport) return;

  emit("select", props.item);
};

const clickEdit = () => {
  router.push({
    name: "treeholeSelfSetting",
    query: {
      mateUuid: props.item.uuid,
    },
  });
};

const clickImport = async () => {
  try {
    await showConfirmDialog({
      title: "导入",
      message: "导入角色后，将会克隆一个该角色添加到自设列表中",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    });
  } catch {
    return;
  }

  const {
    name,
    gender,
    birthday,
    race,
    occupation,
    bio,
    personalityPrompt,
    tag,
    mediaId,
    mediaUrl,
  } = props.item;

  const loading = showLoadingToast({
    message: "导入中...",
    duration: 0,
  });

  const mate = await mateStore.createMate({
    name,
    gender: gender || 0,
    mediaId: mediaId || 0,
    mediaUrl: mediaUrl || "",
    personalityPrompt: personalityPrompt || "",
    tag: tag || "",
    type: MateType.SelfAvatar,
  });

  await mateStore.updateMateDetail(mate.uuid, {
    bio: bio || "",
    personalityPrompt: personalityPrompt || "",
    tag: tag || "",
    birthday: birthday || "",
    race: race || "",
    occupation: occupation || "",
  });

  await mateStore.publish(mate.uuid, false);

  loading.close();
};
</script>
